import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";  // 페이지 이동을 위해 useNavigate 사용
import FaqList from "./components/FaqList";
import SupportTabs from "../MyPage/components/SupportTabs";
import left from "../../assets/icons/Arrow/left.svg"
import { useFixedLayout } from "../../hooks/useFixedLayout";
import { HeaderIconL } from "../../assets/components/HeaderGroup";

const Faq = () => {
    const [faqList, setFaqList] = useState([]);
    const navigate = useNavigate(); // useNavigate 훅 사용

    const location = useLocation();
    const type = location.state?.type || {};  // 없을 수도 있으니 fallback 필요
    const storeBusinessNumber = location.state.storeBusinessNumber

    const { headerRef, headerSpace } = useFixedLayout();

    useEffect(() => {
        const fetchFaq = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/faq`);
                setFaqList(response.data);
            } catch (error) {
                console.error("공지사항 불러오기 실패:", error);
            }
        };
        fetchFaq();
    }, []);

    // 글쓰기 페이지로 이동
    const handleCreateFaq = () => {
        navigate('/ads/faq/create', { state: { storeBusinessNumber : storeBusinessNumber, type : type }}); // '/ads/notice/create' 경로로 이동
    };

    // 🔄 뒤로 가기(홈)
    const handleHome = () => {
        navigate("/ads/main", { state: { tab: "mypage" }});
    }

    // const handleBack = () => {
    //     navigate("/ads/admin", { state: { type: type } });
    // }
    

    return (
        <div className="mx-auto ">
            {/* <div className="flex text-2xl">
                {type === "admin" ? (
                    <button
                        onClick={handleHome}
                        className="flex items-center text-gray-600 hover:text-black mb-4 h-7"
                    >
                        {/* ✕ 
                        <FiArrowLeft />
                    </button>
                ) : (
                    <button
                        onClick={handleHome}
                        className="flex items-center text-gray-600 hover:text-black mb-4 h-7"
                    >
                            {/* ✕ 
                            <FiArrowLeft />
                    </button>
                )}

                <h2 className="text-xl font-bold pl-2 pb-6">자주 묻는 질문</h2>
            </div> */}

            <div ref={headerRef} className="fixed top-0 left-0 right-0 z-10">
                <HeaderIconL
                    icon={left}
                    onIconClick={handleHome}
                    title="고객지원"
                />
                <SupportTabs />
            </div>

            <div style={{ paddingTop: headerSpace }}>

                {/* 글쓰기 버튼 */}
                {type === "admin" && (
                    <div className="p-4">
                        <button
                            onClick={handleCreateFaq}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                        >
                            등록
                        </button>
                    </div>
                )}

                {/* AdsNoticeList 컴포넌트 사용 */}
                <FaqList
                    faqList={faqList}
                    setFaqList={setFaqList} 
                    storeBusinessNumber = {storeBusinessNumber}
                    type  = {type}
                />
            </div>
        </div>
    );
};

export default Faq;